/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether the organization has hook telemetry configured. True when any source is set up; it says nothing about whether traffic has arrived.
 */
export type HooksStatus = {
  /**
   * An active hooks-scoped API key exists, as minted by the hooks setup dialog, the plugin download or the setup wizard.
   */
  agentHooksKey: boolean;
  /**
   * An enabled Anthropic inference hooks integration is connected.
   */
  anthropicInferenceHooks: boolean;
  /**
   * True when at least one hook source is configured for the organization.
   */
  configured: boolean;
};

/** @internal */
export const HooksStatus$inboundSchema: z.ZodMiniType<HooksStatus, unknown> = z
  .pipe(
    z.object({
      agent_hooks_key: z.boolean(),
      anthropic_inference_hooks: z.boolean(),
      configured: z.boolean(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "agent_hooks_key": "agentHooksKey",
        "anthropic_inference_hooks": "anthropicInferenceHooks",
      });
    }),
  );

export function hooksStatusFromJSON(
  jsonString: string,
): SafeParseResult<HooksStatus, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HooksStatus$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HooksStatus' from JSON`,
  );
}
